import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import { loadJobForApplicationSuccess } from '../../jobapplication/store/actions'
import { JOB } from '../../search/constants'
import * as searchActions from '../../search/store/actions'

import {
  disableExtendedQualifiedViewTracking,
  disableQualifiedViewTracking,
  disableUserInteractionTracking,
  trackInitialSearch,
  trackManualSearch,
  trackNumResults
} from './actions'
import {
  DEFAULT_INITIAL_SEARCH_TRACKED,
  DEFAULT_MANUAL_SEARCH,
  DEFAULT_MANUAL_SEARCH_TRACKED,
  DEFAULT_NUM_RESULTS_TRACKED,
  DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING,
  DEFAULT_DISABLE_USER_INTERACTION_TRACKING,
  DEFAULT_DISABLE_EXTENDED_QUALIFIED_VIEW_TRACKING
} from './defaultState'

const manualSearch = handleActions({
  [combineActions(searchActions.setSearchQuery, searchActions.setSearchType)]: () => true,
  [combineActions(searchActions.resetSearchFilters, searchActions.setSearchFilters)]: () => true
}, DEFAULT_MANUAL_SEARCH)

const initialSearchTracked = handleActions({
  [trackInitialSearch]: () => true
}, DEFAULT_INITIAL_SEARCH_TRACKED)

const manualSearchTracked = handleActions({
  [trackManualSearch]: () => true,
  [combineActions(searchActions.setSearchQuery, searchActions.setSearchType)]: () => false,
  [combineActions(searchActions.resetSearchFilters, searchActions.setSearchFilters)]: () => false
}, DEFAULT_MANUAL_SEARCH_TRACKED)

const numResultsTracked = handleActions({
  [trackNumResults]: () => true,
  [combineActions(searchActions.setSearchQuery, searchActions.setSearchType)]: () => false,
  [combineActions(searchActions.resetSearchFilters, searchActions.setSearchFilters)]: () => false
}, DEFAULT_NUM_RESULTS_TRACKED)

const qualifiedTrackingDisabled = handleActions({
  [combineActions(searchActions.job.setSelectedId, searchActions.company.setSelectedId)]: () => (
    DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING
  ),
  [loadJobForApplicationSuccess]: (state, { payload: { jobForApplication } }) => ({ ...state, [JOB]: !jobForApplication?.id }),
  [disableQualifiedViewTracking]: (state, { payload: contentType }) => ({ ...state, [contentType]: true })
}, DEFAULT_DISABLE_QUALIFIED_VIEW_TRACKING)

const extendedQualifiedTrackingDisabled = handleActions({
  [combineActions(searchActions.job.setSelectedId, searchActions.company.setSelectedId)]: () => (
    DEFAULT_DISABLE_EXTENDED_QUALIFIED_VIEW_TRACKING
  ),
  [loadJobForApplicationSuccess]: (state, { payload: { jobForApplication } }) => ({ ...state, [JOB]: !jobForApplication?.id }),
  [disableExtendedQualifiedViewTracking]: (state, { payload }) => ({ ...state, ...payload })
}, DEFAULT_DISABLE_EXTENDED_QUALIFIED_VIEW_TRACKING)

const userInteractionTrackingDisabled = handleActions({
  [combineActions(searchActions.job.setSelectedId, searchActions.company.setSelectedId)]: () => (
    DEFAULT_DISABLE_USER_INTERACTION_TRACKING
  ),
  [loadJobForApplicationSuccess]: (state, { payload: { jobForApplication } }) => ({ ...state, [JOB]: !jobForApplication?.id }),
  [disableUserInteractionTracking]: (state, { payload: contentType }) => ({ ...state, [contentType]: true })
}, DEFAULT_DISABLE_USER_INTERACTION_TRACKING)

export default combineReducers({
  manualSearch,
  initialSearchTracked,
  manualSearchTracked,
  numResultsTracked,
  qualifiedTrackingDisabled,
  extendedQualifiedTrackingDisabled,
  userInteractionTrackingDisabled
})
